/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface PdfRequest {
    id: number;
}

export interface PreviewRequest {
    id: number;
}

/**
 * NoticesApi - interface
 * 
 * @export
 * @interface NoticesApiInterface
 */
export interface NoticesApiInterface {
    /**
     * 
     * @param {number} id A unique integer value identifying this notice.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticesApiInterface
     */
    pdfRaw(requestParameters: PdfRequest): Promise<runtime.ApiResponse<Blob>>;

    /**
     */
    pdf(requestParameters: PdfRequest): Promise<Blob>;

    /**
     * Preview snapshot of a contract document. It serves for final revision before printing PDF contracts.
     * @param {number} id A unique integer value identifying this notice.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticesApiInterface
     */
    previewRaw(requestParameters: PreviewRequest): Promise<runtime.ApiResponse<string>>;

    /**
     * Preview snapshot of a contract document. It serves for final revision before printing PDF contracts.
     */
    preview(requestParameters: PreviewRequest): Promise<string>;

}

/**
 * 
 */
export class NoticesApi extends runtime.BaseAPI implements NoticesApiInterface {

    /**
     */
    async pdfRaw(requestParameters: PdfRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling pdf.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/notices/{id}/pdf/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async pdf(requestParameters: PdfRequest): Promise<Blob> {
        const response = await this.pdfRaw(requestParameters);
        return await response.value();
    }

    /**
     * Preview snapshot of a contract document. It serves for final revision before printing PDF contracts.
     */
    async previewRaw(requestParameters: PreviewRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling preview.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/notices/{id}/preview/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Preview snapshot of a contract document. It serves for final revision before printing PDF contracts.
     */
    async preview(requestParameters: PreviewRequest): Promise<string> {
        const response = await this.previewRaw(requestParameters);
        return await response.value();
    }

}
